import { USER_ACTIONS } from '../actions/user.actions';
import { User } from '../../models/user';

export function userReducer(state: User = null, action) {
  switch (action.type) {

    case USER_ACTIONS.LOGIN_USER:
      const currentLanguageId = localStorage.getItem('current_language_id');
      if (currentLanguageId) {
        if (action.payload.languages) {
          const language = action.payload.languages.find(lang => lang.id === parseInt(currentLanguageId, 10));
          if (language) {
            action.payload.currentLanguage = language;
          }
        }
      }
      return Object.assign({}, state, action.payload);

    case USER_ACTIONS.LOGOUT_USER:
      localStorage.removeItem('current_language_id');
      return state = null;

    case USER_ACTIONS.CHANGE_LANGUAGE:
      localStorage.setItem('current_language_id', action.payload.id);
      return Object.assign({}, state, { currentLanguage: action.payload });

    case USER_ACTIONS.UPDATE_PROFILE:
      state.profiles.forEach((profile, index) => {
        if (profile.id === action.payload.id) {
          state.profiles[index] = action.payload;
        }
      });
      return Object.assign({}, state);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/user.reducer.ts